import React, { useRef, useEffect } from "react";
import "./style.scss";
import classNames from "classnames";
import { loadScrollMagic, mobileIs, getOverallSettingsClasses } from "../../utils/siteUtils";
import { BodyText, Heading, Image } from "../../elements";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import PrimaryButton from "../../elements/primary-button";
import Videojs from "../video-js";
import gsap from "gsap";
import { gtag } from "../../utils";

const WaterfallFlow = props => {
  const { fields, params, rendering, page } = props;
  const { items, scrollToInitialPosition } = fields;
  const { Variant, showTextOnImage } = params;
  const mainEl = useRef(null);
  // console.log(fields, "WaterfallFlow");

  const rootId = `waterfall-flow__${rendering.uid}`;
  const mainId = `waterfall-flow__main${rendering.uid}`;

  const onScroll = () => {
    (items || []).map((item, index) => {
      if (!item?.fields.videoNode) return;
      const { videoIsPlaying } = item?.fields.videoNode.state;
      const rect = mainEl?.current.getBoundingClientRect();
      const winHeight = window.innerHeight || document.documentElement.clientHeight;
      const inScreen = (rect.top >= 0 && rect.top <= winHeight) || (rect.bottom >= 0 && rect.bottom <= winHeight);
      if (inScreen && !videoIsPlaying && item?.fields.autoplay.value) {
        setTimeout(() => {
          item.fields.videoNode.player.play();
        }, 20);
      }
      return;
    });
  };
  const gtagClk = () => {
    gtag('event', 'Component_info', {
      'component_name': 'WaterfallFlow',
      'page_title': page?.name
    });
  };
  useEffect(() => {
    let scrollTop = localStorage.getItem('scrollTop');
    if (scrollTop && scrollToInitialPosition?.value) {
      localStorage.removeItem('scrollTop');
      let timer = setTimeout((v) => {
        window.scrollTo({
          top: scrollTop,
          behavior: 'smooth',
        });
        clearTimeout(timer)
      }, 500)
    }
    const ScrollMagic = loadScrollMagic();
    let controller = new ScrollMagic.Controller();

    const refreshScrollMagic = () => {
      if (controller) {
        controller.update();
      }
    };

    items.forEach((item, index) => {
      const tl = gsap.timeline();

      tl.add(
        gsap.to(
          `#waterfall-flowItemId__${item.id} .waterfall-flow__item-main__title-header,
        #waterfall-flowItemId__${item.id} .waterfall-flow__item-main__title-body,
        #waterfall-flowItemId__${item.id} .waterfall-flow__item-main__button`,
          {
            y: 1,
            opacity: 1,
            duration: 0.2
          }
        )
      ).add(
        gsap.to(
          `#waterfall-flowItemId__${item.id} .waterfall-flow__item-media .waterfall-flow__item-image,
    #waterfall-flowItemId__${item.id} .waterfall-flow__item-media .video-container video,
    #waterfall-flowItemId__${item.id} .waterfall-flow__item-media .video-container .vjs-poster`,
          {
            scale: 1.02,
            duration: 0.2
          }
        )
      );

      new ScrollMagic.Scene({
        triggerElement: `#waterfall-flowItemId__${item.id}`,
        triggerHook: mobileIs() ? "onCenter" : "onEnter",
        duration: 0,
        reverse: true
      })
        .setTween(tl)
        .addTo(controller);

      const itemImage = document.querySelector(`#waterfall-flowItemId__${item.id} .waterfall-flow__item-image`);
      if (itemImage) {
        if (itemImage.complete) {
          refreshScrollMagic();
        } else {
          itemImage.addEventListener('load', refreshScrollMagic);
        }
      }
    });

    setTimeout(refreshScrollMagic, 300);

    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      controller.destroy(true);
      controller = null;
    };
  }, []);
  const rootClasses = classNames("waterfall-flow", "grid", getOverallSettingsClasses(fields));
  return (
    <div className={classNames(rootClasses, { radius: Variant === 'radius' })} datasourceid={rendering.dataSource} id={rootId}>
      <div className={"waterfall-flow__main"} ref={mainEl} id={mainId}>
        {(items || []).map((item, index) => {
          const { alignment, headingType, headingBody, mobile_headingBody, body, mobile_body, cta, image, video, autoplay, textOnImage, mobile_textOnImage } = item.fields;
          let headingValue = mobileIs() ? mobile_headingBody : headingBody;
          let bodyValue = mobileIs() ? mobile_body : body;
          let imageTextValue = mobileIs() ? mobile_textOnImage : textOnImage;
          const itemClasses = classNames("waterfall-flow__item", alignment?.fields?.key?.value, autoplay.value ? 'autoplay' : '');
          const itemId = `waterfall-flowItemId__${item.id}`;
          const videoOptions =
            video && video.value
              ? {
                sources: [
                  {
                    src: video.value.src,
                    type: video.value.mimeType
                  }
                ],
                poster: image.value.src,
                autoplay: autoplay,
                controls: !autoplay?.value,
                loop: autoplay?.value,
                // muted: autoplay.value
              }
              : {};
          return (
            <div id={itemId} className={itemClasses} key={index}>
              <div className={"waterfall-flow__item-media"}>
                {/*<Image {...image?.value} className={"waterfall-flow__item-image"} />*/}
                {image.value && video && !video.value && <Image {...image.value} className={"waterfall-flow__item-image"} />}
                {video && video.value && <Videojs ref={e => (item.fields.videoNode = e)} {...videoOptions} />}

                {
                  showTextOnImage && <RichText className="waterfall-flow__item-text-on-image" field={imageTextValue}></RichText>
                }
              </div>
              <div className={"waterfall-flow__item-main"}>
                <Heading className={"waterfall-flow__item-main__title-header"} type={headingType} html={headingValue} />
                <BodyText className={"waterfall-flow__item-main__title-body"} html={bodyValue} />
                {cta && (
                  <div className="waterfall-flow__item-main__button" onClick={(e) => gtagClk()}>
                    <PrimaryButton
                      {...{
                        ...cta?.fields,
                        callback: evt => {
                          let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                          localStorage.setItem('scrollTop', scrollTop);
                        }
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default WaterfallFlow;
